<template>

<div>
  <div class="card risk_profile"
       v-if="isGranted([permissions.PROCESS_RISK_VIEW, permissions.PROCESS_RISK_VIEW_OWN], process)"
       qid="risk-section"
       id="update_risk_profile"
  >
    <div class="card-header" :class="{'pr-0 pl-0': showOnTask}">
      <div class="float-right">
        <ValidationForm
            :object="process"
            type="risk_profile"
            scope="validate_risk_profile"
            @validationModalClose="handleValidationModalClose"
            v-if="!showOnTask && isGranted([permissions.PROCESS_RISK_VALIDATION, permissions.PROCESS_RISK_VALIDATION_OWN], process)"
        ></ValidationForm>

        <span class="btn btn-success"
              @click="showFormFunction"
              qid="risk-edit-button"
              v-if="isGranted([permissions.PROCESS_RISK_EDIT, permissions.PROCESS_RISK_EDIT_OWN], process)"
        >
            <font-awesome-icon icon="pen"/> {{ $t('system.edit') }}
          </span>
      </div>
      <div class="float-left">
        <h5 class="mb-2" qid="risk-table-title" v-if="!showOnTask">
          {{ $t('processes.risk_profile.title') }}
        </h5>

        <span v-if="!showOnTask">
          <span class="cursor-pointer task-label-open mr-2"
                v-if="getTask('update_risk_profile')"
          >
            <UpdateSingleTaskModal
                :task="getTask('update_risk_profile')"
                @reloadContent="reloadContent"
                :editIcon="true"
            ></UpdateSingleTaskModal>
          </span>
          <span v-if="getGuide('update_risk_profile')">
            <GuideButton :guide="getGuide('update_risk_profile')"></GuideButton>
          </span>
        </span>
      </div>

      <div class="validation-info" qid="view-risk-validation" v-if="process.risk_profile_validation && !showOnTask">
        <span v-if="process.risk_profile_validation && process.risk_profile_validation.validation === 1">
          <font-awesome-icon icon="check-circle" class="icon-success"/>
          {{ $t('system.approved') }}
        </span>
        <span v-if="process.risk_profile_validation && process.risk_profile_validation.validation === 0">
          <font-awesome-icon icon="times-circle" class="icon-danger"/>
          {{ $t('system.rejected') }}
        </span>
        <span v-if="process.risk_profile_validation" class="text-muted font-italic">
          {{ $t('system.by') }}
          <span v-if="process.risk_profile_validation.created_by" qid="view-risk-validation-by">
            {{ process.risk_profile_validation.created_by.name }}
          </span>
        </span>
        <span v-if="process.risk_profile_validation" class="text-muted font-italic">
          {{ $t('system.on') }}
          <span v-if="process.risk_profile_validation.created_at" qid="view-risk-validation-date">
            {{ process.risk_profile_validation.created_at | formatDate }}
          </span>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pb-0">

          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('processes.risk.dpia_label') }}</label>
            <b-form-radio-group
              v-model="dpia"
              :options="radioOptions"
              qid="dpia-form-radio"
            ></b-form-radio-group>
          </div>
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.dpia_label') }}</label>
            <div v-if="process.gdpr">
              <p qid="risk-dpia" class="section-container" v-if="process.gdpr.risk_dpia">
                <span v-if="process.gdpr.risk_dpia">
                  {{ $t('system.' + $options.filters.slugify(process.gdpr.risk_dpia)) }}
                </span>
              </p>
              <p v-if="!process.gdpr.risk_dpia" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('processes.risk.impact_label') }}</label>
            <multiselect
                v-model="selectedImpact"
                :options="impactItems"
                :placeholder="$t('processes.risk.impact_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="risk-form-impact"
            ></multiselect>
          </div>
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.impact_label') }}</label>
            <div v-if="process.gdpr">
              <p :qid="'risk-impact-' + process.gdpr.risk_impact" class="section-container" v-if="process.gdpr.risk_impact">
                <span v-if="process.gdpr.risk_impact">
                  {{ $t('impact.' + $options.filters.slugify(process.gdpr.risk_impact)) }}
                </span>
                &nbsp;
              </p>
              <p v-if="!process.gdpr.risk_impact" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('processes.risk.probability_label') }}</label>
            <multiselect
                v-model="selectedProbability"
                :options="probabilityItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('processes.risk.probability_placeholder')"
                label="name"
                qid="risk-form-probability"
            ></multiselect>
          </div>
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.probability_label') }}</label>
            <div v-if="process.gdpr">
              <p :qid="'risk-probability-' + process.gdpr.risk_probability" class="section-container" v-if="process.gdpr.risk_impact">
                <span v-if="process.gdpr.risk_probability">
                  {{ $t('probability.' + $options.filters.slugify(process.gdpr.risk_probability)) }}
                </span>
                &nbsp;
              </p>
              <p v-if="!process.gdpr.risk_impact" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.risk_label') }}</label>
            <div v-if="process.gdpr">
              <p :qid="'risk-risk-' + process.gdpr.risk_risk.risk" class="section-container" v-if="process.gdpr.risk_risk.number">
                <font-awesome-icon
                  icon="exclamation-triangle"
                  v-if="process.gdpr.risk_risk.number"
                  :class="[ process.gdpr.risk_risk.number ? 'risk-'+process.gdpr.risk_risk.number : 'risk' ]"
                />
                <span v-if="process.gdpr.risk_risk.risk">
                  {{ $t('risk.' + $options.filters.slugify(process.gdpr.risk_risk.risk)) }}
                </span>
                <span v-if="process.gdpr.risk_risk.number">
                  ({{process.gdpr.risk_risk.number}})
                </span>
                &nbsp;
              </p>
              <p v-if="!process.gdpr.risk_risk.number" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('processes.risk.description_label') }}</label>
            <b-form-textarea
              qid="risk-form-description"
              v-model="description"
              rows="4"
              :placeholder="$t('processes.risk.description_placeholder')"
            ></b-form-textarea>
          </div>
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.description_label') }}</label>
            <div v-if="process.gdpr">
              <p class="text-formatted section-container"
                 qid="risk-description"
                 v-if="process.gdpr.risk_description"
                 style="min-height: 105px;"
              >{{process.gdpr.risk_description}}</p>
              <p v-if="!process.gdpr.risk_description" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('processes.risk.action_label') }}</label>
            <b-form-textarea
              qid="risk-action-description"
              v-model="action"
              rows="4"
              :placeholder="$t('processes.risk.action_placeholder')"
            ></b-form-textarea>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="cancelForm"
                        qid="risk-form-cancel-button"
              >
                {{ $t('processes.legal_basis.create.cancel') }}
              </b-button>
              <b-button class="mt-3 ml-3"
                        variant="success"
                        @click="formSubmit"
                        qid="risk-form-submit-button"
              >
                {{ $t('processes.legal_basis.create.submit') }}
              </b-button>
            </div>
          </div>
          <div v-if="!showForm">
            <label for="">{{ $t('processes.risk.action_label') }}</label>
            <div class="text-formatted section-container"
                 v-if="process.gdpr && process.gdpr.risk_action_plan"
                 qid="risk-action-plan"
                 style="min-height: 105px;"
            >{{process.gdpr.risk_action_plan}}</div>
            <p v-if="!process.gdpr.risk_action_plan" class="text-muted section-container">
              {{ $t('system.missing_input') }}
            </p>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-sm-12">
        <div class="card-body pt-0 pb-0">
          <label v-if="isGranted([permissions.PROCESS_RISK_EDIT, permissions.PROCESS_RISK_EDIT_OWN], process)"
                 class="btn btn-secondary cursor-pointer float-right"
                 qid="create-p-file-button"
          >
            <input type="file"
                   name="fileupload"
                   value="fileupload"
                   multiple
                   id="file"
                   @change="onFileChange"
                   @click="resetFile"
            >
            <span>
              <font-awesome-icon icon="cloud-upload-alt" />
              {{ $t('system.upload') }}
            </span>
          </label>
          <label for="">
            <span>
              {{ $t('attachments.label') }}
              <br>
              <span>({{ $t('attachments.file_size_label') }})</span>
            </span>
          </label>
          <div v-if="!showForm" class="">
            <b-alert v-if="error.length"
                     show
                     variant="danger"
                     qid="attachments-p-error"
            >
              {{ error }}
            </b-alert>
            <p v-for="file in process.media" class="section-container">
              <span class="float-right text-muted cursor-pointer"
                    @click="openDeleteAttachmentModal(file)"
                    qid="remove-media-item"
                    v-if="isGranted([permissions.PROCESS_RISK_EDIT, permissions.PROCESS_RISK_EDIT_OWN], process)"
              >
                <font-awesome-icon icon="trash-alt" />
              </span>
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a @click="downloadMedia(file)" qid="create-p-media-item">
                {{ file.file_name }}
              </a>
            </p>

            <p v-if="!process.media.length" class="text-muted section-container">
              {{ $t('system.missing_input') }}
            </p>

          </div>
        </div>
        <br>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-sm-12">
        <div class="card-body pt-0">
          <span class="btn btn-link cursor-pointer float-right pt-0"
                @click="showInput = true"
                qid="add-another-link"
                v-if="isGranted([permissions.PROCESS_RISK_EDIT, permissions.PROCESS_RISK_EDIT_OWN], process)"
          >
            <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
          </span>
          <label for="">
            <span>
              {{ $t('links.label') }}
            </span>
          </label>
          <div class="" v-if="!showForm">
            <div v-if="process.links">
              <p v-for="link in process.links" class="section-container">
                <span class="float-right text-muted cursor-pointer"
                      @click="openDeleteLinkModal(link)"
                      qid="view-p-remove-link"
                      v-if="isGranted([permissions.PROCESS_RISK_EDIT, permissions.PROCESS_RISK_EDIT_OWN], process)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
                <a :href="link.url" target="_blank" qid="create-p-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>

            <p v-if="!process.links.length" class="text-muted section-container">
              {{ $t('system.missing_input') }}
            </p>

            <div v-if="showInput">
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="text-center mb-2 pt-2 card-body" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="validationShow = !validationShow"
                qid="expand-risk-validations"
          >
            <span class="mr-2">{{ $t('system.view_validation_log') }}</span>
            <font-awesome-icon icon="chevron-down" v-if="!validationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="validationShow"/>
          </span>
        </div>
        <div v-show="validationShow && !showOnTask" class="card-body">
          <ValidationList
              :object="process"
              type="risk_profile"
              :reloadList="updateValidationList"
              @validationListUpdated="setValidation"
          ></ValidationList>
        </div>
      </div>
    </div>

  </div>

  <ConfirmRemoveAttachment
      :object="selectedFile"
      :show="showDeleteAttachmentModal"
      type="file"
      @closeConfirmModal="closeDeleteAttachmentModal"
  ></ConfirmRemoveAttachment>

  <ConfirmRemoveAttachment
      :object="selectedLink"
      :show="showDeleteLinkModal"
      type="link"
      @closeConfirmModal="closeDeleteLinkModal"
  ></ConfirmRemoveAttachment>

</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'Riskprofile',
    data: function() {
      return {
        form: {

        },
        selectedImpact: [],
        selectedProbability: [],
        description: '',
        action: '',
        dpia: '',
        error: '',
        loadingItems: false,
        validationShow: false,
        updateValidationList: false,
        showForm: false,
        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        probabilityItems: [
          { name: this.$t('probability.very_unlikely'), value: 'Very unlikely' },
          { name: this.$t('probability.unlikely'), value: 'Unlikely' },
          { name: this.$t('probability.likely'), value: 'Likely' },
          { name: this.$t('probability.very_likely'), value: 'Very likely' }
        ],
        radioOptions: [
          {text: this.$t('system.yes'), value: 'Yes'},
          {text: this.$t('system.no'), value: 'No'}
        ],
        validation: [],
        process: {},
        showInput: false,
        inputLink: '',
        inputLinkName: '',
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object
      },
      showOnTask: {},
      task: {}
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    components: {
      ValidationForm,
      ValidationList,
      ConfirmRemoveAttachment,
      UpdateSingleTaskModal,
      GuideButton
    },
    watch: {
      object: function (value) {
        this.process = value
        this.setDefaultForm(value)
        this.loadTasks('update_risk_profile');
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.process.id && this.$store.state.updatedObject.who_am_i == this.process.who_am_i) {
              this.process = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_risk_profile')
        }
      },
    },
    methods: {
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      reloadContent() {
        this.loadProcess()
        this.loadTasks('update_risk_profile');
      },
      setValidation(object) {
        this.process.risk_profile_validation = object
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.process.who_am_i,
              model_id: this.process.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Process' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Process',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      formSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        this.form.type = 'risk_profile';

        this.form.risk_impact = ''
        this.form.risk_probability = ''
        if (this.selectedImpact) {
          this.form.risk_impact = this.selectedImpact.value;
        }
        if (this.selectedProbability) {
          this.form.risk_probability = this.selectedProbability.value;
        }
        this.form.risk_description = this.description;
        this.form.risk_action_plan = this.action;
        this.form.risk_dpia = this.dpia;

        piincHttp.put('processes/' + this.process.slug, this.form).then(function(response) {
          self.process = response.data
          self.$emit('updated');
          self.showForm = false;
          self.loadTasks('update_risk_profile');
          self.$toastr('success', self.$t('processes.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadProcess();
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadProcess();
      },
      handleValidationModalClose() {
        this.loadProcess();
        this.updateValidationList = true
      },
      cancelForm() {
        this.showForm = false
      },
      showFormFunction() {
        this.setDefaultForm(this.object)
        this.showForm = true
      },
      loadProcess() {
        let self = this;
        piincHttp.get('processes/' + this.process.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.process = response.data;
        }, function() {});
      },
      setDefaultForm(object) {
        if (object.gdpr.risk_impact) {
          this.selectedImpact = _.find(this.impactItems, function(item) {
            return item.value === object.gdpr.risk_impact;
          });
        } else {
          this.selectedImpact = []
        }
        if (object.gdpr.risk_probability) {
          this.selectedProbability = _.find(this.probabilityItems, function(item) {
            return item.value === object.gdpr.risk_probability;
          });
        } else {
          this.selectedProbability = []
        }
        this.description = this.process.gdpr.risk_description;
        this.action = this.process.gdpr.risk_action_plan;
        this.dpia = this.process.gdpr.risk_dpia;
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      handleLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.process.who_am_i);
        formData.append("model_id", this.process.id);

        piincHttp.post('links', formData).then(function() {
          self.$toastr('success', self.$t('maintenance.third_parties.link_add_success'))
          self.loadProcess()
          self.inputLink = ''
          self.inputLinkName = ''
          self.showInput = false
        }, function() {})
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.process.who_am_i);
        formData.append("model_id", this.process.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.$toastr('success', self.$t('maintenance.third_parties.media_add_success'))
            self.error = ''
            self.loadProcess()
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
    },
    created () {
      this.process = this.object

      if (this.process && this.process.slug) {
        this.loadTasks('update_risk_profile');
      }

      this.loadGuides('update_risk_profile');
    }
  }
</script>
